var map = {
	"./alfa_leasing.svg": 40373,
	"./aliexpress.svg": 99952,
	"./ar.svg": 62784,
	"./aviasales.svg": 92261,
	"./avito.svg": 68226,
	"./best_doctor.svg": 33719,
	"./cdek.svg": 3502,
	"./cian.svg": 78734,
	"./det_mir.svg": 62002,
	"./dodo.svg": 68391,
	"./ekoniva.svg": 40164,
	"./haier.svg": 10746,
	"./innopolis.svg": 22331,
	"./innova.svg": 66009,
	"./interfax.svg": 93815,
	"./komus.svg": 31387,
	"./krok.svg": 48621,
	"./lamoda.svg": 98656,
	"./lanit.svg": 98652,
	"./leroy_merlin.svg": 8103,
	"./megafon.svg": 21118,
	"./modulbank.svg": 67160,
	"./ostrovok.svg": 69812,
	"./pik.svg": 65873,
	"./rbk_money.svg": 74090,
	"./ru_center.svg": 36376,
	"./samokat.svg": 24868,
	"./segmento.svg": 36949,
	"./selectel.svg": 55012,
	"./simple.svg": 87323,
	"./skyeng.svg": 44041,
	"./splat.svg": 26221,
	"./sports_ru.svg": 29138,
	"./uchi_ru.svg": 37709,
	"./vk.svg": 25763,
	"./yandex_praktikum.svg": 18765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33738;